import { api } from ".";
import { TicketPayload } from "../@types/ticket";
import { Tag } from "../pages/selectTickets/useEdit";
import { JobResultItem } from "../types/Jobs";
import { getMetaData, getZendeskUrl, zafClient } from "./zendesk";

export const formatPayload = (data: any) => {
    const brandId = data.filter(
        (item: { field: string }) => item.field === "brand_id"
    );

    const assigneeId = data.filter(
        (item: { field: string }) => item.field === "assignee_id"
    );

    const groupId = data.filter(
        (item: { field: string }) => item.field === "group_id"
    );

    const ticketFormId = data.filter(
        (item: { field: string }) => item.field === "ticket_form_id"
    );

    const tagResult = data.filter(
        (item: { field: string }) => item.field === "tags"
    );

    const organizationId = data.filter(
        (item: { field: string }) => item.field === "organization_id"
    );

    const customFields = data.filter(
        (item: { field: string }) => item.field === "custom_fields"
    );

    const customStatusId = data.filter(
        (item: { field: string }) => item.field === "custom_status_id"
    );

    const requesterEmail = data.filter(
        (item: { field: string }) => item.field === "requester_email"
    );

    const ticketType = data.filter(
        (item: { field: string }) => item.field === "type"
    );

    return {
        brand_id: brandId[brandId.length - 1]?.value,
        assignee_id: assigneeId[assigneeId.length - 1]?.value,
        group_id: groupId[groupId.length - 1]?.value,
        ticket_form_id: ticketFormId[ticketFormId.length - 1]?.value,
        organization_id: organizationId[organizationId.length - 1]?.value,
        additional_tags: tagResult[tagResult.length - 1]?.value,
        custom_fields: customFields[customFields.length - 1]?.value,
        custom_status_id: customStatusId[customStatusId.length - 1]?.value,
        requester_email: requesterEmail[requesterEmail.length - 1]?.value,
        type: ticketType[ticketType.length - 1]?.value,
    };
};

export const updateManyTickets = async (
    data: TicketPayload
): Promise<string> => {
    const response = await api.put("/update-many-tickets", data);
    const jobUrl = response.data.results[0].response.job_status.url;
    return jobUrl;
};

export const getJobResult = async (
    url: string,
    updateProgress: (progress: number) => void,
    offset: number
): Promise<JobResultItem[]> => {
    const options = {
        url,
        type: "GET",
    };

    while (true) {
        const response = await zafClient.request(options);

        const jobStatus = response.job_status.status;
        const currentTicket = response.job_status.progress ?? 0;

        updateProgress(offset + currentTicket);

        if (jobStatus === "completed") {
            return response.job_status.results as JobResultItem[];
        }

        await new Promise(r => setTimeout(r, 1000));
    }
};



export const getFieldsUser = async (params: any) => {
    const response = await api.get("/get-fields-users", {
        params: params
    });
    return response.data
}

export const getFieldsOrganization = async (params: any) => {
    const response = await api.get("/get-fields-organization", {
        params: params
    });
    return response.data
}

export const createManyUsers = async (payload: any) => {
    const response = await api.post("/create-many-users", payload);
    return response;
};

export const createManyOrganizations = async (payload: any) => {
    const response = await api.post("/create-many-organizations", payload);
    return response;
};

export const createManyTickets = async (payload: any) => {
    const response = await api.post("/create-many-tickets", payload);
    return response;
}

export const getJobStatus = async (job_id: string, params: any) => {
    const response = await api.get(`/job-status/${job_id}`, {
        params: params,
    });

    return response;
};

export async function getTicketForms(params: any) {
    const res = await api.get(`/ticket-forms`, {
        params: params
    });
    return res.data;
}

export async function getFieldsTicketByForm(formId: number | null, params: any) {
    const queryParam = formId === null ? "" : `?form_id=${formId}`
    const res = await api.get(`/get-fields-tickets${queryParam}`, {
        params: params
    });
    return res.data;
}

export const getStatuses = async () => {
    const metadata = await getMetaData();
    const response = await api.get("/statuses", {
        params: {
            email: metadata.emailAdmin,
            token: metadata.apiToken,
            subdomain: getZendeskUrl(),
        }
    });
    return response.data;
}

export const getTicket = async (tags: Tag[], page: number = 1, per_page: number = 50) => {
    const metadata = await getMetaData();
    const response = await api.post("/get-tickets", {
        headers: {
            "Content-Type": "application/json",
        },
        data: {
            "email": metadata.emailAdmin,
            "token": metadata.apiToken,
            "subdomain": getZendeskUrl(),
            "tags": tags,
            "page": page,
            "per_page": per_page,
        }
    });
    return response.data
}

export const getUser = async (tags: Tag[]) => {
    const metadata = await getMetaData();

    const response = await api.post(
        "/get-users",
        {
            data: {
                email: metadata.emailAdmin,
                token: metadata.apiToken,
                subdomain: getZendeskUrl(),
                tags: tags,
            }
        },
        {
            headers: {
                "Content-Type": "application/json",
            }
        }
    );

    return response.data;
};

export const getOrganization = async (tags: Tag[]) => {
    const metadata = await getMetaData();
    const response = await api.post(
        "/get-organizations",
        {
            data: {
                email: metadata.emailAdmin,
                token: metadata.apiToken,
                subdomain: getZendeskUrl(),
                tags: tags,
            }
        },
        {
            headers: {
                "Content-Type": "application/json",
            }
        }
    );

    return response.data;
}
